// theme/theme.ts
import { createTheme, Theme } from '@mui/material/styles';

export const getTheme = (mode: 'light' | 'dark'): Theme =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: '#ffa100',
      },
      secondary: {
        main: '#ed2020',
      },
      ...(mode === 'dark'
        ? {
            background: {
              default: '#121212',
              paper: '#1e1e1e',
            },
            text: {
              primary: '#ffffff',
              secondary: '#bbbbbb',
            },
          }
        : {
            background: {
              default: '#ffffff',
              paper: '#f8f8f8',
            },
            text: {
              primary: '#212529',
              secondary: '#4b5563',
            },
          }),
    },
    typography: {
      fontFamily: "'Inter', 'Roboto', 'Segoe UI', sans-serif",
    },
  });
